// extracted by mini-css-extract-plugin
export default {"container":"clientContracts_container__zVr2h"};